<template>
  <main class="dashboard" style="background: #fff">
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css">

    <header>
      <div class="container">
        <div class="header-content">
          <div class="logo">
            <div class="logo-icon">
              <i class="fas fa-exchange-alt"></i>
            </div>
            <div class="logo-text">
              <h1>API сервиса «Reputation Analytics» </h1>
              <p>Документация по интеграции и использованию</p>
            </div>
          </div>
          <div class="version">
            Версия 2.0
          </div>
        </div>
      </div>
    </header>

    <div class="container">
      <!-- Navigation Tabs -->
      <div class="nav-tabs">
        <div class="nav-tab active" data-tab="overview">
          <i class="fas fa-home"></i> Обзор
        </div>
        <div class="nav-tab" data-tab="authentication">
          <i class="fas fa-key"></i> Аутентификация
        </div>
        <div class="nav-tab" data-tab="sending">
          <i class="fas fa-paper-plane"></i> Отправка запросов
        </div>
        <div class="nav-tab" data-tab="receiving">
          <i class="fas fa-download"></i> Получение PDF
        </div>
        <div class="nav-tab" data-tab="examples">
          <i class="fas fa-code"></i> Примеры кода
        </div>
        <div class="nav-tab" data-tab="reference">
          <i class="fas fa-book"></i> Справочник
        </div>
      </div>

      <!-- Tab Contents -->
      <div id="overview" class="tab-content active">
        <div class="card">
          <div class="card-header">
            <div class="card-icon">
              <i class="fas fa-sync-alt"></i>
            </div>
            <div>
              <h2 class="card-title">Двухэтапный процесс работы</h2>
              <p class="card-subtitle">Отправка запроса → Обработка → Получение файла</p>
            </div>
          </div>

          <div class="two-column">
            <div>
              <h3><i class="fas fa-arrow-up"></i> Этап 1: Отправка запроса</h3>
              <ul class="feature-list">
                <li>Клиент отправляет зашифрованные данные через API</li>
                <li>Данные содержат информацию для обратной связи</li>
                <li>Указывается callback-URL для получения результата</li>
                <li>Каждый запрос имеет уникальный идентификатор</li>
                <li>Все запросы подписываются и проверяются на целостность</li>
              </ul>
            </div>
            <div>
              <h3><i class="fas fa-arrow-down"></i> Этап 2: Получение PDF</h3>
              <ul class="feature-list">
                <li>Сервис обрабатывает запрос и генерирует PDF</li>
                <li>Файл отправляется на указанный callback-URL</li>
                <li>PDF зашифрован и содержит цифровую подпись</li>
                <li>Автоматические повторные попытки при ошибках</li>
                <li>Детальное логирование всех операций</li>
              </ul>
            </div>
          </div>

        </div>

        <div class="card">
          <div class="card-header">
            <div class="card-icon">
              <i class="fas fa-shield-alt"></i>
            </div>
            <div>
              <h2 class="card-title">Безопасность и шифрование</h2>
              <p class="card-subtitle">Многоуровневая защита данных</p>
            </div>
          </div>

          <div class="two-column">
            <div>
              <h4><i class="fas fa-lock"></i> Методы защиты</h4>
              <ul class="feature-list">
                <li>HMAC-подписи для проверки целостности</li>
                <li>Шифрование всех чувствительных данных</li>
                <li>Защита от replay-атак через nonce</li>
                <li>Временные метки для предотвращения устаревших запросов</li>
                <li>Валидация доменов callback-URL</li>
              </ul>
            </div>
            <div>
              <h4><i class="fas fa-key"></i> Криптография</h4>
              <ul class="feature-list">
                <li>Симметричное шифрование для данных</li>
                <li>Base64 кодирование для передачи</li>
                <li>SHA-256 для хеширования</li>
                <li>Уникальные ключи для каждого клиента</li>
                <li>Регулярная ротация ключей</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="card">
    <div class="card-header">
        <div class="card-icon">
            <i class="fas fa-exclamation-circle"></i>
        </div>
        <div>
            <h2 class="card-title">Важно! Особенность кодирования</h2>
            <p class="card-subtitle">Двойное Base64-кодирование зашифрованных данных</p>
        </div>
    </div>

    <div class="alert alert-warning">
        <div class="alert-icon">
            <i class="fas fa-info-circle"></i>
        </div>
        <div>
            <p><strong>Важно:</strong> Зашифрованные данные передаются с двойным Base64-кодированием.
            Это связано с тем, что библиотека Fernet (используемая в Python) возвращает данные в формате
            URL-safe Base64, которые затем дополнительно кодируются в стандартный Base64.</p>
        </div>
    </div>

    <h3>🔄 Алгоритм кодирования (на стороне Python-сервиса)</h3>

    <div class="process-flow" style="margin: 20px 0;">
        <div class="process-step">
            <div class="step-icon">
                <i class="fas fa-database"></i>
            </div>
            <h3>Исходные <br>данные</h3>
            <p>JSON структура</p>
        </div>

        <div class="step-arrow"></div>

        <div class="process-step">
            <div class="step-icon">
                <i class="fas fa-lock"></i>
            </div>
            <h3>Fernet<br> шифрование</h3>
            <p>Криптография</p>
        </div>

        <div class="step-arrow"></div>

        <div class="process-step">
            <div class="step-icon" >
                <i class="fas fa-code"></i>
            </div>
            <h3>URL-safe<br> Base64</h3>
            <p>Автоматически Fernet</p>
        </div>

        <div class="step-arrow"></div>

        <div class="process-step">
            <div class="step-icon">
                <i class="fas fa-layer-group"></i>
            </div>
            <h3>Стандартный Base64</h3>
            <p>Дополнительное кодирование</p>
        </div>
    </div>

    <div class="code-block">
        <div class="code-header">
            <div class="code-title">Текстовое представление алгоритма</div>
        </div>
        <pre>1. Исходные данные → JSON → Fernet шифрование
2. Fernet шифрование → URL-safe Base64 (автоматически)
3. URL-safe Base64 → Стандартный Base64 (дополнительное кодирование)</pre>
    </div>

    <h3>💻 Примеры кода для декодирования</h3>

    <div class="language-tabs">
        <div class="tab-buttons">
            <button class="lang-tab active" data-lang="js">JavaScript</button>
            <button class="lang-tab" data-lang="python">Python</button>
            <button class="lang-tab" data-lang="java">Java</button>
            <button class="lang-tab" data-lang="php">PHP</button>
            <button class="lang-tab" data-lang="csharp">C#</button>
        </div>

        <div class="tab-content2 active" id="js-tab">
            <div class="code-block">
                <div class="code-header">
                    <div class="code-title">JavaScript / Node.js</div>
                    <button class="copy-btn" onclick="copyCode('js-example')">
                        <i class="fas fa-copy"></i> Копировать
                    </button>
                </div>
                <pre id="js-example"><code><span class="comment">// Получаем строку в стандартном Base64</span>
<span class="keyword">const</span> base64Data = <span class="string">"Z0FBQUFBQnBlS..."</span>; <span class="comment">// Пример полученных данных</span>

<span class="comment">// Двойное декодирование:</span>
<span class="comment">// 1. Декодируем стандартный Base64 → получаем URL-safe Base64 строку</span>
<span class="keyword">const</span> urlSafeBase64Str = Buffer.from(base64Data, <span class="string">'base64'</span>).toString(<span class="string">'utf-8'</span>);

<span class="comment">// 2. Декодируем URL-safe Base64 → получаем зашифрованные байты</span>
<span class="keyword">const</span> encryptedBytes = Buffer.from(urlSafeBase64Str, <span class="string">'base64'</span>);

<span class="comment">// 3. Расшифровываем Fernet (используйте соответствующую библиотеку)</span>
<span class="comment">// const decrypted = crypto.decrypt(encryptedBytes);</span></code></pre>
            </div>
        </div>

        <div class="tab-content2" id="python-tab">
            <div class="code-block">
                <div class="code-header">
                    <div class="code-title">Python</div>
                    <button class="copy-btn" onclick="copyCode('python-example')">
                        <i class="fas fa-copy"></i> Копировать
                    </button>
                </div>
                <pre id="python-example"><code><span class="keyword">import</span> base64

<span class="comment"># Получаем строку в стандартном Base64</span>
base64_data = <span class="string">"Z0FBQUFBQnBlS..."</span>

<span class="comment"># 1. Декодируем стандартный Base64 → получаем URL-safe Base64 строку</span>
urlsafe_base64_str = base64.b64decode(base64_data).decode(<span class="string">'utf-8'</span>)

<span class="comment"># 2. Расшифровываем Fernet</span>
decrypted_data = fernet.decrypt(urlsafe_base64_str.encode()).decode(<span class="string">'utf-8'</span>)</code></pre>
            </div>
        </div>

        <div class="tab-content2" id="java-tab">
            <div class="code-block">
                <div class="code-header">
                    <div class="code-title">Java</div>
                    <button class="copy-btn" onclick="copyCode('java-example')">
                        <i class="fas fa-copy"></i> Копировать
                    </button>
                </div>
                <pre id="java-example"><code><span class="keyword">import</span> java.util.Base64;

<span class="comment">// Получаем строку в стандартном Base64</span>
String base64Data = <span class="string">"Z0FBQUFBQnBlS..."</span>;

<span class="comment">// 1. Декодируем стандартный Base64 → получаем URL-safe Base64 строку</span>
<span class="keyword">byte</span>[] urlSafeBytes = Base64.getDecoder().decode(base64Data);
String urlSafeBase64Str = <span class="keyword">new</span> String(urlSafeBytes, <span class="string">"UTF-8"</span>);

<span class="comment">// 2. Конвертируем URL-safe Base64 в стандартный формат</span>
String standardBase64 = urlSafeBase64Str
    .replace(<span class="string">'-'</span>, <span class="string">'+'</span>)
    .replace(<span class="string">'_'</span>, <span class="string">'/'</span>);

<span class="comment">// 3. Декодируем → получаем зашифрованные байты</span>
<span class="keyword">byte</span>[] encryptedBytes = Base64.getDecoder().decode(standardBase64);</code></pre>
            </div>
        </div>

        <div class="tab-content2" id="php-tab">
            <div class="code-block">
                <div class="code-header">
                    <div class="code-title">PHP</div>
                    <button class="copy-btn" onclick="copyCode('php-example')">
                        <i class="fas fa-copy"></i> Копировать
                    </button>
                </div>
                <pre id="php-example"><code><span class="comment">// Получаем строку в стандартном Base64</span>
$base64Data = <span class="string">"Z0FBQUFBQnBlS..."</span>;

<span class="comment">// 1. Декодируем стандартный Base64 → получаем URL-safe Base64 строку</span>
$urlSafeBase64Str = base64_decode($base64Data);

<span class="comment">// 2. Конвертируем URL-safe Base64 в стандартный формат</span>
$standardBase64 = str_replace(['-', '_'], ['+', '/'], $urlSafeBase64Str);

<span class="comment">// 3. Декодируем → получаем зашифрованные байты</span>
$encryptedBytes = base64_decode($standardBase64);</code></pre>
            </div>
        </div>

        <div class="tab-content2" id="csharp-tab">
            <div class="code-block">
                <div class="code-header">
                    <div class="code-title">C# / .NET</div>
                    <button class="copy-btn" onclick="copyCode('csharp-example')">
                        <i class="fas fa-copy"></i> Копировать
                    </button>
                </div>
                <pre id="csharp-example"><code><span class="keyword">using</span> System;
<span class="keyword">using</span> System.Text;

<span class="comment">// Получаем строку в стандартном Base64</span>
string base64Data = <span class="string">"Z0FBQUFBQnBlS..."</span>;

<span class="comment">// 1. Декодируем стандартный Base64 → получаем URL-safe Base64 строку</span>
<span class="keyword">byte</span>[] urlSafeBytes = Convert.FromBase64String(base64Data);
string urlSafeBase64Str = Encoding.UTF8.GetString(urlSafeBytes);

<span class="comment">// 2. Конвертируем URL-safe Base64 в стандартный формат</span>
string standardBase64 = urlSafeBase64Str
    .Replace(<span class="string">'-'</span>, <span class="string">'+'</span>)
    .Replace(<span class="string">'_'</span>, <span class="string">'/'</span>);

<span class="comment">// 3. Декодируем → получаем зашифрованные байты</span>
<span class="keyword">byte</span>[] encryptedBytes = Convert.FromBase64String(standardBase64);</code></pre>
            </div>
        </div>
    </div>


    <h3>🆘 Если возникают ошибки</h3>

    <div class="table-container">
        <table>
            <thead>
                <tr>
                    <th style="width: 30%;">Ошибка</th>
                    <th style="width: 40%;">Возможная причина</th>
                    <th style="width: 30%;">Решение</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td><code>"Invalid base64"</code></td>
                    <td>Неправильная конвертация URL-safe Base64</td>
                    <td>Проверьте замену символов: <code>- → +</code>, <code>_ → /</code></td>
                </tr>
                <tr>
                    <td><code>Fernet error</code></td>
                    <td>Некорректные байты после декодирования</td>
                    <td>Убедитесь, что выполнили оба этапа декодирования</td>
                </tr>
                <tr>
                    <td><code>Padding error</code></td>
                    <td>Отсутствуют символы выравнивания <code>=</code></td>
                    <td>Добавьте <code>=</code> до длины кратной 4 символам</td>
                </tr>
                <tr>
                    <td><code>Character encoding</code></td>
                    <td>Неправильная кодировка строки UTF-8</td>
                    <td>Убедитесь в использовании UTF-8 для декодирования</td>
                </tr>
            </tbody>
        </table>
    </div>

    <div class="alert alert-warning">
        <div class="alert-icon">
            <i class="fas fa-lightbulb"></i>
        </div>
        <div>
            <p><strong>Совет:</strong> Для отладки используйте промежуточную проверку данных. После каждого этапа
            декодирования выводите тип и размер данных, чтобы убедиться в корректности обработки.</p>
        </div>
    </div>
</div>


      </div>

      <div id="authentication" class="tab-content">
        <div class="card">
          <div class="card-header">
            <div class="card-icon">
              <i class="fas fa-user-check"></i>
            </div>
            <div>
              <h2 class="card-title">Получение учетных данных</h2>
              <p class="card-subtitle">Что нужно для начала работы</p>
            </div>
          </div>

          <p>Для интеграции с сервисом обратитесь к администратору для получения:</p>

          <div class="table-container">
            <table>
              <thead>
              <tr>
                <th>Параметр</th>
                <th>Описание</th>
                <th>Пример</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td><code>api_key</code> <span class="required">*</span></td>
                <td>Ключ для авторизации в API</td>
                <td><code>sk_live_abc123...</code></td>
              </tr>
              <tr>
                <td><code>client_id</code> <span class="required">*</span></td>
                <td>Идентификатор вашей организации</td>
                <td><code>client_xyz789</code></td>
              </tr>
              <tr>
                <td><code>master_encryption_key</code> <span class="required">*</span></td>
                <td>Ключ для шифрования данных</td>
                <td><code>Gm...==</code> (Fernet key)</td>
              </tr>
              <tr>
                <td><code>secret_key</code> <span class="required">*</span></td>
                <td>Ключ для подписи запроса</td>
                <td><code>abc123...</code></td>
              </tr>
              </tbody>
            </table>
          </div>

          <div class="alert alert-warning">
            <div class="alert-icon">
              <i class="fas fa-exclamation-triangle"></i>
            </div>
            <div>
              <strong>Важно:</strong> Никогда не храните ключи в коде приложения. Используйте переменные окружения или
              секреты.
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-header">
            <div class="card-icon">
              <i class="fas fa-heading"></i>
            </div>
            <div>
              <h2 class="card-title">Обязательные заголовки запроса</h2>
              <p class="card-subtitle">Все запросы должны содержать эти заголовки</p>
            </div>
          </div>

          <div class="table-container">
            <table>
              <thead>
              <tr>
                <th>Заголовок</th>
                <th>Описание</th>
                <th>Обязательный</th>
                <th>Пример</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td><code>Authorization</code></td>
                <td>Тип и API ключ: <code>Bearer &lt;api_key&gt;</code></td>
                <td><span class="status status-success">Да</span></td>
                <td><code>Bearer sk_live_abc123...</code></td>
              </tr>
              <tr>
                <td><code>X-Orion-Nonce</code></td>
                <td>Уникальный идентификатор запроса (UUID)</td>
                <td><span class="status status-success">Да</span></td>
                <td><code>550e8400-e29b-41d4-a716-446655440000</code></td>
              </tr>
              <tr>
                <td><code>X-Orion-Timestamp</code></td>
                <td>Временная метка в секундах (Unix timestamp)</td>
                <td><span class="status status-success">Да</span></td>
                <td><code>1625097600</code></td>
              </tr>
              <tr>
                <td><code>X-Orion-Signature</code></td>
                <td>HMAC подпись запроса</td>
                <td><span class="status status-success">Да</span></td>
                <td><code>a1b2c3d4e5f6...</code> (64 chars)</td>
              </tr>
              <tr>
                <td><code>Content-Type</code></td>
                <td>Тип содержимого: <code>application/json</code></td>
                <td><span class="status status-success">Да</span></td>
                <td><code>application/json</code></td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div id="sending" class="tab-content">
        <div class="card">
          <div class="card-header">
            <div class="card-icon">
              <i class="fas fa-server"></i>
            </div>
            <div>
              <h2 class="card-title">Отправка запроса на обратную связь</h2>
              <p class="card-subtitle">Endpoint для создания нового запроса</p>
            </div>
          </div>

          <div class="endpoint">
            <div>
              <span class="endpoint-method">POST</span>
              <span class="endpoint-path">https://reputation-analytics.ru/api/v1/client/feedback/</span>
            </div>
            <p class="endpoint-description">Создает новый запрос на обратную связь. После обработки сервис отправит PDF
              на указанный callback-URL.</p>

            <h3>Формат запроса</h3>
            <div class="code-block">
              <div class="code-header">
                <div class="code-title">JSON Body</div>
                <button class="copy-btn" onclick="copyCode('request-body')">
                  <i class="fas fa-copy"></i> Копировать
                </button>
              </div>
              <pre id="request-body"><code>{
  <span class="string">"encrypted_data"</span>: <span class="string">"base64_encoded_encrypted_payload"</span>
}</code></pre>
            </div>

            <h3>Структура шифрованных данных</h3>
            <div class="code-block">
              <div class="code-header">
                <div class="code-title">Исходные данные перед шифрованием</div>
                <button class="copy-btn" onclick="copyCode('source-data')">
                  <i class="fas fa-copy"></i> Копировать
                </button>
              </div>
              <pre id="source-data"><code>{
  <span class="string">"client_id"</span>: <span class="string">"your_client_id"</span>,
  <span class="string">"feedback_id"</span>: <span class="string">"unique_feedback_id"</span>,
  <span class="string">"callback_url"</span>: <span class="string">"https://your-domain.com/webhook/pdf"</span>,
  <span class="string">"full_name"</span>: <span class="string">"Иван Иванов"</span>,
  <span class="string">"comment"</span>: <span class="string">"Дополнительный комментарий"</span>
}</code></pre>
            </div>

            <h3>Поля данных</h3>
            <div class="table-container">
              <table>
                <thead>
                <tr>
                  <th>Поле</th>
                  <th>Тип</th>
                  <th>Обязательный</th>
                  <th>Описание</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td><code>client_id</code></td>
                  <td>string</td>
                  <td><span class="status status-success">Да</span></td>
                  <td>Идентификатор клиента, выданный системой</td>
                </tr>
                <tr>
                  <td><code>feedback_id</code></td>
                  <td>string</td>
                  <td><span class="status status-success">Да</span></td>
                  <td>Уникальный ID запроса в вашей системе</td>
                </tr>
                <tr>
                  <td><code>callback_url</code></td>
                  <td>string</td>
                  <td><span class="status status-success">Да</span></td>
                  <td>URL для отправки PDF-файла</td>
                </tr>
                <tr>
                  <td><code>full_name</code></td>
                  <td>string</td>
                  <td><span class="status status-success">Да</span></td>
                  <td>ФИО для обратной связи</td>
                </tr>
                <tr>
                  <td><code>comment</code></td>
                  <td>string</td>
                  <td><span class="status status-warning">Нет</span></td>
                  <td>Дополнительная информация</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-header">
            <div class="card-icon">
              <i class="fas fa-signature"></i>
            </div>
            <div>
              <h2 class="card-title">Генерация подписи запроса</h2>
              <p class="card-subtitle">Как правильно подписать запрос</p>
            </div>
          </div>

          <div class="code-block">
            <div class="code-header">
              <div class="code-title">Python: Создание payload для подписи</div>
              <button class="copy-btn" onclick="copyCode('sign-payload')">
                <i class="fas fa-copy"></i> Копировать
              </button>
            </div>
            <pre id="sign-payload"><code><span class="keyword">def</span> <span class="function">create_payload</span>(data, nonce, timestamp):
    <span class="string">"""Создание payload с nonce и timestamp для signature"""</span>
    items = list(data.items())
    items.append((<span class="string">"nonce"</span>, nonce))
    items.append((<span class="string">"timestamp"</span>, timestamp))
    items.sort()
    <span class="keyword">return</span> <span class="string">";"</span>.join([<span class="string">":"</span>.join([str(key), str(value)]) <span
                  class="keyword">for</span> key, value <span class="keyword">in</span> items])</code><br> <br>
verification_data = {<span class="string">"encrypted_data"</span>: encrypted_data, <span class="string">"nonce"</span>: nonce, <span
                  class="string">"timestamp"</span>: timestamp}
<span class="function">create_payload</span>(verification_data)
            </pre>
          </div>

          <ol>
            <li>Создайте payload строку из <code>encrypted_data</code>, <code>nonce</code> и <code>timestamp</code></li>
            <li>Отсортируйте все пары ключ-значение по алфавиту</li>
            <li>Объедините в строку формата <code>key1:value1;key2:value2;...</code></li>
            <li>Подпишите payload с использованием вашего приватного ключа</li>
            <li>Закодируйте в base64</li>
            <li>Добавьте подпись в заголовок <code>X-Orion-Signature</code></li>
          </ol>

          <div class="alert alert-info">
            <div class="alert-icon">
              <i class="fas fa-lightbulb"></i>
            </div>
            <div>
              <strong>Совет:</strong> Используйте <code>hmac.compare_digest()</code> для безопасного сравнения подписей
              вместо обычного сравнения строк.
            </div>
          </div>
        </div>
        <div class="card">
    <div class="card-header">
        <div class="card-icon">
            <i class="fas fa-exclamation-circle"></i>
        </div>
        <div>
            <h2 class="card-title">Важно: Base64 кодирование после шифрования</h2>
            <p class="card-subtitle">Обязательный шаг для передачи данных</p>
        </div>
    </div>

    <div class="alert alert-warning">
        <div class="alert-icon">
            <i class="fas fa-exclamation-triangle"></i>
        </div>
        <div>
            <strong>Обязательная последовательность:</strong> Шифрование → Base64 → Передача
        </div>
    </div>

    <p>После шифрования <strong>полученные бинарные данные необходимо преобразовать в Base64</strong> перед отправкой через API.</p>

    <h3>Причина:</h3>
    <p>Шифрование создает <strong>бинарные данные</strong> (байты), а HTTP/JSON работают только с <strong>текстовыми строками</strong>. Base64 преобразует бинарные данные в безопасную текстовую форму.</p>

    <div class="two-column">
        <div>
            <h4><i class="fas fa-check-circle" style="color: #28a745;"></i> Правильно:</h4>
            <div class="code-block">
                <pre><code><span class="comment"># ШИФРУЕМ + BASE64</span>
<span class="keyword">encrypted</span> = fernet.encrypt(data.encode())
<span class="keyword">encrypted_b64</span> = base64.b64encode(<span class="keyword">encrypted</span>).decode()
<span class="comment"># → Отправляем encrypted_b64 в JSON</span></code></pre>
            </div>
        </div>
        <div>
            <h4><i class="fas fa-times-circle" style="color: #dc3545;"></i> Неправильно:</h4>
            <div class="code-block">
                <pre><code><span class="comment"># ТОЛЬКО ШИФРОВАНИЕ</span>
<span class="keyword">encrypted</span> = fernet.encrypt(data.encode())
<span class="comment"># → Пытаемся отправить бинарные данные в JSON</span>
<span class="comment"># → ОШИБКА: данные будут повреждены!</span></code></pre>
            </div>
        </div>
    </div>

    <h3>Полный цикл обработки:</h3>
    <div class="code-block">
        <div class="code-header">
            <div class="code-title">Минимальный рабочий код</div>
        </div>
        <pre><code><span class="comment"># === КЛИЕНТ: отправка ===</span>
<span class="keyword">data</span> = <span class="string">"Секретные данные"</span>
<span class="keyword">encrypted</span> = fernet.encrypt(<span class="keyword">data</span>.encode())  <span class="comment"># → бинарные данные</span>
<span class="keyword">encrypted_b64</span> = base64.b64encode(<span class="keyword">encrypted</span>).decode()  <span class="comment"># → текст</span>
<span class="comment"># Отправляем encrypted_b64 в поле "encrypted_data"</span>

<span class="comment"># === СЕРВЕР: получение ===</span>
<span class="keyword">encrypted_b64</span> = request.data[<span class="string">"encrypted_data"</span>]  <span class="comment"># ← получаем текст</span>
<span class="keyword">encrypted</span> = base64.b64decode(<span class="keyword">encrypted_b64</span>)  <span class="comment"># → бинарные данные</span>
<span class="keyword">decrypted</span> = fernet.decrypt(<span class="keyword">encrypted</span>).decode()  <span class="comment"># → исходные данные</span></code></pre>
    </div>

    <div class="alert alert-info">
        <div class="alert-icon">
            <i class="fas fa-lightbulb"></i>
        </div>
        <div>
            <strong>Критически важно:</strong><br>
            ❌ <strong>Нельзя отправлять:</strong> Бинарные данные напрямую в JSON<br>
            ✅ <strong>Обязательно:</strong> Base64 кодирование после шифрования
        </div>
    </div>
</div>
      </div>

      <div id="receiving" class="tab-content">
        <div class="card">
          <div class="card-header">
            <div class="card-icon">
              <i class="fas fa-file-pdf"></i>
            </div>
            <div>
              <h2 class="card-title">Получение PDF через callback</h2>
              <p class="card-subtitle">Структура callback-запроса от сервиса</p>
            </div>
          </div>

          <h3>Заголовки callback-запроса</h3>
          <div class="table-container">
            <table>
              <thead>
              <tr>
                <th>Заголовок</th>
                <th>Описание</th>
                <th>Пример</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td><code>Content-Type</code></td>
                <td><code>application/json</code></td>
                <td><code>application/json</code></td>
              </tr>
              <tr>
                <td><code>Content-Disposition</code></td>
                <td>Имя файла для сохранения</td>
                <td><code>attachment; filename="feedback_123.pdf"</code></td>
              </tr>
              <tr>
                <td><code>X-Orion-Feedback-ID</code></td>
                <td>ID обратной связи</td>
                <td><code>feedback_123</code></td>
              </tr>
              <tr>
                <td><code>X-Orion-Client-ID</code></td>
                <td>ID клиента</td>
                <td><code>client_xyz789</code></td>
              </tr>
              <tr>
                <td><code>X-Orion-Signature</code></td>
                <td>HMAC подпись запроса</td>
                <td><code>a1b2c3d4e5f6...</code></td>
              </tr>
              <tr>
                <td><code>X-Orion-Nonce</code></td>
                <td>Уникальный идентификатор запроса</td>
                <td><code>550e8400-e29b-41d4-a716-446655440000</code></td>
              </tr>
              <tr>
                <td><code>X-Orion-Timestamp</code></td>
                <td>Временная метка</td>
                <td><code>1625097600</code></td>
              </tr>
              </tbody>
            </table>
          </div>


          <h3>Тело callback-запроса</h3>
          <div class="code-block">
            <div class="code-header">
              <div class="code-title">JSON Body</div>
              <button class="copy-btn" onclick="copyCode('request-body')">
                <i class="fas fa-copy"></i> Копировать
              </button>
            </div>
            <pre id="request-body"><code>{
  <span class="string">"encrypted_file"</span>: <span class="string">"base64_encoded_encrypted_payload",</span>
  <span class="string">"encrypted_data"</span>: <span class="string">"base64_encoded_encrypted_payload"</span>
  <span class="string">"nonce"</span>: <span class="string">"unique_nonce"</span>,
  <span class="string">"timestamp"</span>: <span class="string">"unix_timestamp"</span>
}</code></pre>
          </div>

          <h3>Структура шифрованных данных</h3>
          <div class="code-block">
            <div class="code-header">
              <div class="code-title">Исходные данные перед шифрованием</div>
              <button class="copy-btn" onclick="copyCode('source-data')">
                <i class="fas fa-copy"></i> Копировать
              </button>
            </div>
            <pre id="source-data"><code>{
  <span class="string">"feedback_id"</span>: <span class="string">"your_feedback_id"</span>,
  <span class="string">"client_id"</span>: <span class="string">"your_client_id"</span>,
  <span class="string">"file_hash"</span>: <span class="string">"sha256_hash_of_pdf_content"</span>,
}</code></pre>
          </div>

        </div>

        <div class="card">
          <div class="card-header">
            <div class="card-icon">
              <i class="fas fa-check-double"></i>
            </div>
            <div>
              <h2 class="card-title">Верификация callback</h2>
              <p class="card-subtitle">Шаги проверки входящего запроса</p>
            </div>
          </div>

          <div class="two-column">
            <div>
              <h4>1. Проверка временной метки</h4>
              <div class="code-block">
                            <pre><code><span class="keyword">current_time</span> = int(time.time())
<span class="keyword">request_time</span> = int(headers.get(<span class="string">'X-Orion-Timestamp'</span>))

<span class="keyword">if</span> abs(current_time - request_time) > <span class="number">300</span>:  <span
                                  class="comment"># 5 минут</span>
    <span class="keyword">return</span> {<span class="string">"error"</span>: <span
                                  class="string">"Timestamp expired"</span>}, <span
                                  class="number">400</span></code></pre>
              </div>

              <h4>2. Проверка nonce (защита от replay-атак)</h4>
              <div class="code-block">
                            <pre><code><span class="keyword">nonce</span> = headers.get(<span class="string">'X-Orion-Nonce'</span>)
<span class="keyword">if</span> nonce <span class="keyword">in</span> used_nonces:
    <span class="keyword">return</span> {<span class="string">"error"</span>: <span class="string">"Request already processed"</span>}, <span
                                  class="number">400</span>
used_nonces.add(nonce)</code></pre>
              </div>
            </div>
            <div>
              <h4>3. Проверка подписи</h4>
              <div class="code-block">
                            <pre><code><span class="keyword">payload_items</span> = [
    (<span class="string">"encrypted_data"</span>, data[<span class="string">"encrypted_data"</span>]),
    (<span class="string">"nonce"</span>, data[<span class="string">"nonce"</span>]),
    (<span class="string">"timestamp"</span>, data[<span class="string">"timestamp"</span>])
]
<span class="comment">// Сортировка и создание строки</span>
<span class="comment">// Проверка подписи</span></code></pre>
              </div>

              <h4>4. Расшифровка и сохранение PDF</h4>
              <div class="code-block">
                            <pre><code><span class="keyword">encrypted_pdf</span> = base64.b64decode(data[<span
                                class="string">"encrypted_file"</span>])
<span class="keyword">pdf_content</span> = decrypt_data(encrypted_pdf)

<span class="comment">// Проверка хеша файла</span>
<span class="keyword">file_hash</span> = hashlib.sha256(pdf_content).hexdigest()
<span class="keyword">if</span> file_hash != data[<span class="string">"file_hash"</span>]:
    <span class="keyword">return</span> {<span class="string">"error"</span>: <span class="string">"File integrity check failed"</span>}, <span
                                  class="number">400</span></code></pre>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="examples" class="tab-content">
        <div class="card">
    <div class="card-header">
        <div class="card-icon" style="background: linear-gradient(135deg, #4cc9f0 0%, #4361ee 100%);">
            <i class="fas fa-code"></i>
        </div>
        <div>
            <h2 class="card-title">Полный пример отправки запроса</h2>
            <p class="card-subtitle">Готовый код для интеграции</p>
        </div>
    </div>

    <h3>Настройка конфигурации</h3>
    <div class="code-block">
        <div class="code-header">
            <div class="code-title">Конфигурационные параметры</div>
            <button class="copy-btn" onclick="copyCode('config-code')">
                <i class="fas fa-copy"></i> Копировать
            </button>
        </div>
        <pre id="config-code"><code><span class="comment"># Обязательные параметры (получить у администратора)</span>
<span class="keyword">ENDPOINT_URL</span> = <span class="string">"https://reputation-analytics.ru/api/v1/client/feedback/"</span>
<span class="keyword">CLIENT_ID</span> = <span class="string">"your_client_id_here"</span>
<span class="keyword">API_KEY</span> = <span class="string">"your_api_key_here"</span>
<span class="keyword">SECRET_KEY</span> = <span class="string">"your_secret_key_here"</span>
<span class="keyword">MASTER_ENCRYPTION_KEY</span> = <span class="string">"your_encryption_key_here="</span>
<span class="keyword">CALLBACK_URL</span> = <span class="string">"https://your-domain.com/webhook/pdf"</span></code></pre>
    </div>

    <div class="alert alert-info">
        <div class="alert-icon">
            <i class="fas fa-key"></i>
        </div>
        <div>
            <strong>Важно:</strong> Все ключи и идентификаторы должны быть получены у администратора сервиса.
            Никогда не храните их в коде приложения — используйте переменные окружения или секреты.
        </div>
    </div>

    <h3>Функция отправки запроса</h3>
    <div class="code-block">
        <div class="code-header">
            <div class="code-title">prepare_request.py</div>
            <button class="copy-btn" onclick="copyCode('request-code')">
                <i class="fas fa-copy"></i> Копировать
            </button>
        </div>
        <pre id="request-code"><code><span class="keyword">def</span> <span class="function">prepare_request</span>():
    <span class="comment"># 1. Инициализация шифрования</span>
    <span class="keyword">fernet</span> = Fernet(<span class="keyword">MASTER_ENCRYPTION_KEY</span>)

    <span class="comment"># 2. Подготовка данных запроса</span>
    <span class="keyword">request_data</span> = {
        <span class="string">"client_id"</span>: <span class="keyword">CLIENT_ID</span>,
        <span class="string">"feedback_id"</span>: <span class="string">f"test_fb_</span>{int(time.time())}<span class="string">"</span>,
        <span class="string">"full_name"</span>: <span class="string">"Иванов Иван Иванович"</span>,
        <span class="string">"comment"</span>: <span class="string">"Тестовый комментарий для проверки работы системы"</span>,
        <span class="string">"callback_url"</span>: <span class="keyword">CALLBACK_URL</span>,
    }

    <span class="comment"># 3. Шифрование данных</span>
    <span class="keyword">json_data</span> = json.dumps(<span class="keyword">request_data</span>)
    <span class="keyword">encrypted</span> = fernet.encrypt(<span class="keyword">json_data</span>.encode())
    <span class="keyword">encrypted_data</span> = base64.urlsafe_b64encode(<span class="keyword">encrypted</span>).decode()

    <span class="comment"># 4. Генерация заголовков безопасности</span>
    <span class="keyword">timestamp</span> = str(int(time.time()))
    <span class="keyword">nonce</span> = str(uuid.uuid4())

    <span class="comment"># 5. Создание payload для подписи</span>
    <span class="keyword">payload_items</span> = [
        (<span class="string">"encrypted_data"</span>, <span class="keyword">encrypted_data</span>),
        (<span class="string">"nonce"</span>, <span class="keyword">nonce</span>),
        (<span class="string">"timestamp"</span>, <span class="keyword">timestamp</span>)
    ]
    <span class="keyword">payload_items</span>.sort()
    <span class="keyword">payload</span> = <span class="string">";"</span>.join([<span class="string">":"</span>.join([str(k), str(v)]) <span class="keyword">for</span> k, v <span class="keyword">in</span> <span class="keyword">payload_items</span>])

    <span class="comment"># 6. Генерация HMAC подписи</span>
    <span class="keyword">signature</span> = hmac.new(
        <span class="keyword">SECRET_KEY</span>.encode(),
        <span class="keyword">payload</span>.encode(),
        hashlib.sha256
    ).hexdigest()

    <span class="comment"># 7. Формирование заголовков запроса</span>
    <span class="keyword">headers</span> = {
        <span class="string">"Authorization"</span>: <span class="string">f"Bearer </span>{<span class="keyword">API_KEY</span>}<span class="string">"</span>,
        <span class="string">"X-Orion-Nonce"</span>: <span class="keyword">nonce</span>,
        <span class="string">"X-Orion-Timestamp"</span>: <span class="keyword">timestamp</span>,
        <span class="string">"X-Orion-Signature"</span>: <span class="keyword">signature</span>,
        <span class="string">"Content-Type"</span>: <span class="string">"application/json"</span>,
        <span class="string">"User-Agent"</span>: <span class="string">"TestClient/1.0"</span>,
    }

    <span class="comment"># 8. Тело запроса</span>
    <span class="keyword">body</span> = {<span class="string">"encrypted_data"</span>: <span class="keyword">encrypted_data</span>}

    <span class="comment"># 9. Отправка запроса</span>
    <span class="keyword">response</span> = requests.post(
        <span class="keyword">ENDPOINT_URL</span>,
        headers=<span class="keyword">headers</span>,
        json=<span class="keyword">body</span>,
        timeout=<span class="number">30</span>
    )
    <span class="keyword">return</span> <span class="keyword">response</span></code></pre>
    </div>

    <div class="two-column">
        <div>
            <h4><i class="fas fa-cogs"></i> Этапы подготовки</h4>
            <ol style="padding-left: 20px; margin-top: 10px;">
                <li>Инициализация шифрования (Fernet)</li>
                <li>Подготовка JSON данных</li>
                <li>Шифрование → Base64 кодирование</li>
                <li>Генерация nonce и timestamp</li>
                <li>Создание payload для подписи</li>
                <li>Генерация HMAC подписи</li>
                <li>Формирование заголовков</li>
                <li>Отправка POST запроса</li>
            </ol>
        </div>
        <div>
            <h4><i class="fas fa-shield-alt"></i> Заголовки безопасности</h4>
            <ul style="padding-left: 20px; margin-top: 10px;">
                <li><code>Authorization</code>: Bearer токен</li>
                <li><code>X-Orion-Nonce</code>: Уникальный идентификатор</li>
                <li><code>X-Orion-Timestamp</code>: Временная метка</li>
                <li><code>X-Orion-Signature</code>: HMAC подпись</li>
                <li><code>Content-Type</code>: application/json</li>
            </ul>
        </div>
    </div>

    <div class="alert alert-warning">
        <div class="alert-icon">
            <i class="fas fa-exclamation-triangle"></i>
        </div>
        <div>
            <strong>Обратите внимание:</strong> В payload для подписи включается только поле <code>encrypted_data</code> вместе с nonce и timestamp.
            Исходные данные (<code>client_id</code>, <code>feedback_id</code> и др.) не включаются, так как они уже зашифрованы внутри <code>encrypted_data</code>.
        </div>
    </div>

    <h3>Использование функции</h3>
    <div class="code-block">
        <div class="code-header">
            <div class="code-title">Пример вызова</div>
            <button class="copy-btn" onclick="copyCode('usage-code')">
                <i class="fas fa-copy"></i> Копировать
            </button>
        </div>
        <pre id="usage-code"><code><span class="comment"># Отправка запроса</span>
<span class="keyword">response</span> = prepare_request()

<span class="comment"># Проверка результата</span>
<span class="keyword">if</span> <span class="keyword">response</span>.status_code == <span class="number">200</span>:
    <span class="keyword">result</span> = <span class="keyword">response</span>.json()
    print(<span class="string">f"Успешно! Nonce: </span>{<span class="keyword">result</span>.get(<span class="string">'nonce'</span>)}<span class="string">"</span>)
<span class="keyword">else</span>:
    print(<span class="string">f"Ошибка </span>{<span class="keyword">response</span>.status_code}<span class="string">: </span>{<span class="keyword">response</span>.text}<span class="string">"</span>)</code></pre>
    </div>
</div>


        <div class="card">
    <div class="card-header">
        <div class="card-icon">
            <i class="fas fa-download"></i>
        </div>
        <div>
            <h2 class="card-title">Обработчик callback для получения PDF</h2>
            <p class="card-subtitle">Полный пример приема и верификации файла</p>
        </div>
    </div>

    <h3>Функция приема callback Python</h3>
    <div class="code-block">
        <div class="code-header">
            <div class="code-title">receive_webhook.py</div>
            <button class="copy-btn" onclick="copyCode('receive-code')">
                <i class="fas fa-copy"></i> Копировать
            </button>
        </div>
        <pre id="receive-code"><code><span class="keyword">def</span> <span class="function">receive_and_decrypt_file</span>(request):
    <span class="keyword">try</span>:
        <span class="comment"># 1. Получение данных и заголовков</span>
        <span class="keyword">data</span> = request.data
        <span class="keyword">headers</span> = request.headers

        <span class="comment"># 2. Извлечение обязательных заголовков</span>
        <span class="keyword">feedback_id</span> = headers.get(<span class="string">"X-Orion-Feedback-ID"</span>)
        <span class="keyword">client_id</span> = headers.get(<span class="string">"X-Orion-Client-ID"</span>)
        <span class="keyword">signature</span> = headers.get(<span class="string">"X-Orion-Signature"</span>)
        <span class="keyword">nonce</span> = headers.get(<span class="string">"X-Orion-Nonce"</span>)
        <span class="keyword">timestamp</span> = headers.get(<span class="string">"X-Orion-Timestamp"</span>)

        <span class="comment"># 3. Проверка наличия всех обязательных заголовков</span>
        <span class="keyword">required_fields</span> = [<span class="keyword">feedback_id</span>, <span class="keyword">client_id</span>, <span class="keyword">signature</span>, <span class="keyword">nonce</span>, <span class="keyword">timestamp</span>]

        <span class="keyword">if</span> <span class="keyword">not</span> all(<span class="keyword">required_fields</span>):
            <span class="comment"># Детальная проверка отсутствующих заголовков</span>
            <span class="keyword">missing</span> = []
            <span class="keyword">if</span> <span class="keyword">not</span> <span class="keyword">feedback_id</span>: <span class="keyword">missing</span>.append(<span class="string">"X-Orion-Feedback-ID"</span>)
            <span class="keyword">if</span> <span class="keyword">not</span> <span class="keyword">client_id</span>: <span class="keyword">missing</span>.append(<span class="string">"X-Orion-Client-ID"</span>)
            <span class="keyword">if</span> <span class="keyword">not</span> <span class="keyword">signature</span>: <span class="keyword">missing</span>.append(<span class="string">"X-Orion-Signature"</span>)
            <span class="keyword">if</span> <span class="keyword">not</span> <span class="keyword">nonce</span>: <span class="keyword">missing</span>.append(<span class="string">"X-Orion-Nonce"</span>)
            <span class="keyword">if</span> <span class="keyword">not</span> <span class="keyword">timestamp</span>: <span class="keyword">missing</span>.append(<span class="string">"X-Orion-Timestamp"</span>)

            <span class="keyword">return</span> JsonResponse(
                {<span class="string">"status"</span>: <span class="string">"error"</span>, <span class="string">"message"</span>: <span class="string">f'Missing required headers: </span>{<span class="string">", "</span>.join(<span class="keyword">missing</span>)}<span class="string">'</span>},
                status=<span class="number">400</span>
            )

        <span class="comment"># 4. Проверка наличия зашифрованных данных</span>
        <span class="keyword">encrypted_data</span> = <span class="keyword">data</span>.get(<span class="string">"encrypted_data"</span>)
        <span class="keyword">encrypted_file</span> = <span class="keyword">data</span>.get(<span class="string">"encrypted_file"</span>)

        <span class="keyword">if</span> <span class="keyword">not</span> <span class="keyword">encrypted_data</span>:
            <span class="keyword">return</span> JsonResponse(
                {<span class="string">"status"</span>: <span class="string">"error"</span>, <span class="string">"message"</span>: <span class="string">"Missing encrypted_data in request body"</span>},
                status=<span class="number">400</span>
            )

        <span class="keyword">if</span> <span class="keyword">not</span> <span class="keyword">encrypted_file</span>:
            <span class="keyword">return</span> JsonResponse(
                {<span class="string">"status"</span>: <span class="string">"error"</span>, <span class="string">"message"</span>: <span class="string">"Missing encrypted_file in request body"</span>},
                status=<span class="number">400</span>
            )

        <span class="comment"># 5. Проверка временной метки (защита от replay-атак)</span>
        <span class="keyword">current_time</span> = int(time.time())
        <span class="keyword">request_timestamp</span> = int(<span class="keyword">timestamp</span>)

        <span class="keyword">if</span> <span class="keyword">current_time</span> - <span class="keyword">request_timestamp</span> > <span class="number">300</span>:
            <span class="keyword">return</span> JsonResponse(
                {<span class="string">"status"</span>: <span class="string">"error"</span>, <span class="string">"message"</span>: <span class="string">"Timestamp expired"</span>},
                status=<span class="number">400</span>
            )

        <span class="keyword">try</span>:
            <span class="comment"># 6. Проверка HMAC подписи</span>
            <span class="keyword">verification_data</span> = {
                <span class="string">"encrypted_data"</span>: <span class="keyword">encrypted_data</span>,
                <span class="string">"nonce"</span>: <span class="keyword">nonce</span>,
                <span class="string">"timestamp"</span>: <span class="keyword">timestamp</span>
            }

            <span class="keyword">payload_string</span> = <span class="string">";"</span>.join([
                <span class="string">":"</span>.join([str(k), str(v)])
                <span class="keyword">for</span> k, v <span class="keyword">in</span> sorted(<span class="keyword">verification_data</span>.items())
            ])

            <span class="keyword">expected_signature</span> = hmac.new(
                <span class="keyword">SECRET_KEY</span>.encode(<span class="string">"utf-8"</span>),
                <span class="keyword">payload_string</span>.encode(<span class="string">"utf-8"</span>),
                hashlib.sha256
            ).hexdigest()

            <span class="keyword">if</span> <span class="keyword">not</span> hmac.compare_digest(<span class="keyword">expected_signature</span>, <span class="keyword">signature</span>):
                <span class="keyword">return</span> JsonResponse(
                    {<span class="string">"status"</span>: <span class="string">"error"</span>, <span class="string">"message"</span>: <span class="string">"Invalid signature"</span>},
                    status=<span class="number">401</span>
                )

        <span class="keyword">except</span> (Exception,):
            <span class="keyword">return</span> JsonResponse(
                {<span class="string">"status"</span>: <span class="string">"error"</span>, <span class="string">"message"</span>: <span class="string">"Signature verification failed"</span>},
                status=<span class="number">401</span>
            )

        <span class="comment"># 7. Инициализация дешифратора</span>
        <span class="keyword">fernet</span> = Fernet(<span class="keyword">MASTER_ENCRYPTION_KEY</span>)

        <span class="keyword">try</span>:
            <span class="comment"># 8. Декодирование и расшифровка метаданных</span>
            <span class="keyword">encrypted_data</span> = base64.urlsafe_b64decode(<span class="keyword">encrypted_data</span>).decode()
            <span class="keyword">decrypted</span> = fernet.decrypt(<span class="keyword">encrypted_data</span>.encode()).decode()
            <span class="keyword">request_data</span> = json.loads(<span class="keyword">decrypted</span>)

        <span class="keyword">except</span> (Exception,):
            <span class="keyword">return</span> JsonResponse(
                {<span class="string">"status"</span>: <span class="string">"error"</span>, <span class="string">"message"</span>: <span class="string">"Failed to decrypt data"</span>},
                status=<span class="number">400</span>
            )

        <span class="keyword">try</span>:
            <span class="comment"># 9. Декодирование и расшифровка файла</span>
            <span class="keyword">encrypted_file_bytes</span> = base64.b64decode(<span class="keyword">encrypted_file</span>)
            <span class="keyword">decrypted_file_content</span> = fernet.decrypt(<span class="keyword">encrypted_file_bytes</span>)

            <span class="comment"># 10. Проверка целостности файла (хеш)</span>
            <span class="keyword">received_hash</span> = <span class="keyword">request_data</span>[<span class="string">"file_hash"</span>]
            <span class="keyword">calculated_hash</span> = hashlib.sha256(<span class="keyword">decrypted_file_content</span>).hexdigest()

            <span class="keyword">if</span> <span class="keyword">received_hash</span> != <span class="keyword">calculated_hash</span>:
                <span class="keyword">return</span> JsonResponse(
                    {<span class="string">"status"</span>: <span class="string">"error"</span>, <span class="string">"message"</span>: <span class="string">"File integrity check failed"</span>},
                    status=<span class="number">400</span>
                )

        <span class="keyword">except</span> (Exception,):
            <span class="keyword">return</span> JsonResponse(
                {<span class="string">"status"</span>: <span class="string">"error"</span>, <span class="string">"message"</span>: <span class="string">"Failed to decrypt file"</span>},
                status=<span class="number">400</span>
            )

        <span class="keyword">try</span>:
            <span class="comment"># 11. Сохранение файла на диск</span>
            <span class="keyword">save_dir</span> = <span class="string">"/home/fiery/"</span>
            <span class="keyword">original_filename</span> = <span class="keyword">request_data</span>.get(<span class="string">"original_filename"</span>, <span class="keyword">request_data</span>[<span class="string">"filename"</span>])
            <span class="keyword">safe_filename</span> = <span class="string">f"</span>{<span class="keyword">feedback_id</span>}<span class="string">_</span>{<span class="keyword">original_filename</span>}<span class="string">"</span>
            <span class="keyword">file_path</span> = os.path.join(<span class="keyword">save_dir</span>, <span class="keyword">safe_filename</span>)

            <span class="keyword">with</span> open(<span class="keyword">file_path</span>, <span class="string">"wb"</span>) <span class="keyword">as</span> f:
                f.write(<span class="keyword">decrypted_file_content</span>)

            <span class="comment"># 12. Формирование успешного ответа</span>
            <span class="keyword">response_data</span> = {
                <span class="string">"status"</span>: <span class="string">"success"</span>,
                <span class="string">"message"</span>: <span class="string">"File received and saved successfully"</span>,
                <span class="string">"data"</span>: {
                    <span class="string">"feedback_id"</span>: <span class="keyword">feedback_id</span>,
                    <span class="string">"client_id"</span>: <span class="keyword">client_id</span>,
                    <span class="string">"file_size"</span>: len(<span class="keyword">decrypted_file_content</span>),
                    <span class="string">"original_filename"</span>: <span class="keyword">original_filename</span>,
                    <span class="string">"received_at"</span>: <span class="keyword">current_time</span>,
                    <span class="string">"hash_verified"</span>: <span class="keyword">True</span>,
                },
            }

            <span class="keyword">return</span> JsonResponse(<span class="keyword">response_data</span>, status=<span class="number">200</span>)

        <span class="keyword">except</span> (Exception,):
            <span class="keyword">return</span> JsonResponse(
                {<span class="string">"status"</span>: <span class="string">"error"</span>, <span class="string">"message"</span>: <span class="string">"Failed to save file"</span>},
                status=<span class="number">500</span>
            )

    <span class="keyword">except</span> (Exception,):
        <span class="keyword">return</span> JsonResponse(
            {<span class="string">"status"</span>: <span class="string">"error"</span>, <span class="string">"message"</span>: <span class="string">"Internal server error"</span>},
            status=<span class="number">500</span>
        )</code></pre>
    </div>

    <div class="two-column">
        <div>
            <h4><i class="fas fa-shield-alt"></i> Этапы проверки безопасности</h4>
            <ol style="padding-left: 20px; margin-top: 10px;">
                <li><strong>Проверка заголовков:</strong> X-Orion-Feedback-ID, X-Orion-Client-ID и др.</li>
                <li><strong>Проверка полей тела:</strong> encrypted_data, encrypted_file</li>
                <li><strong>Валидация timestamp:</strong> Защита от устаревших запросов (5 мин)</li>
                <li><strong>Верификация подписи:</strong> HMAC проверка целостности</li>
                <li><strong>Проверка хеша файла:</strong> SHA256 для целостности содержимого</li>
            </ol>
        </div>
        <div>
            <h4><i class="fas fa-file-download"></i> Этапы обработки файла</h4>
            <ol style="padding-left: 20px; margin-top: 10px;">
                <li><strong>Декодирование Base64:</strong> encrypted_data и encrypted_file</li>
                <li><strong>Расшифровка метаданных:</strong> Fernet.decrypt()</li>
                <li><strong>Расшифровка файла:</strong> Fernet.decrypt() PDF содержимого</li>
                <li><strong>Проверка целостности:</strong> Сравнение SHA256 хешей</li>
                <li><strong>Сохранение на диск:</strong> С безопасным именем файла</li>
            </ol>
        </div>
    </div>


    <div class="alert alert-info">
        <div class="alert-icon">
            <i class="fas fa-info-circle"></i>
        </div>
        <div>
            <strong>Важно:</strong> <code>encrypted_data</code> содержит метаданные файла (включая file_hash),
            а <code>encrypted_file</code> содержит сам PDF файл. Оба поля закодированы в Base64 и зашифрованы.
        </div>
    </div>


</div>

      </div>

      <div id="reference" class="tab-content">
        <div class="card">
          <div class="card-header">
            <div class="card-icon">
              <i class="fas fa-reply"></i>
            </div>
            <div>
              <h2 class="card-title">Коды ответов и ошибок</h2>
              <p class="card-subtitle">Статусы и их значения</p>
            </div>
          </div>

          <h3>Успешные ответы</h3>
          <div class="table-container">
            <table>
              <thead>
              <tr>
                <th>Код</th>
                <th>Статус</th>
                <th>Описание</th>
                <th>Пример ответа</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td><span class="status status-success">200</span></td>
                <td>OK</td>
                <td>Запрос успешно обработан</td>
                <td><code>{"status": "success", "message": "Request successfully registered"}</code></td>
              </tr>
              <tr>
                <td><span class="status status-success">200</span></td>
                <td>OK</td>
                <td>PDF успешно получен (callback)</td>
                <td><code>{"status": "success", "message": "PDF received successfully"}</code></td>
              </tr>
              </tbody>
            </table>
          </div>

          <h3>Ошибки клиента</h3>
          <div class="table-container">
            <table>
              <thead>
              <tr>
                <th>Код</th>
                <th>Статус</th>
                <th>Описание</th>
                <th>Причина</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td><span class="status status-warning">400</span></td>
                <td>Bad Request</td>
                <td>Неверный формат запроса</td>
                <td>Отсутствуют обязательные поля, неверный формат данных</td>
              </tr>
              <tr>
                <td><span class="status status-warning">401</span></td>
                <td>Unauthorized</td>
                <td>Неверный API ключ или подпись</td>
                <td>Неправильный API ключ, неверная подпись, истекший timestamp</td>
              </tr>
              <tr>
                <td><span class="status status-warning">403</span></td>
                <td>Forbidden</td>
                <td>Домен не разрешен</td>
                <td>Callback URL использует неразрешенный домен</td>
              </tr>
              <tr>
                <td><span class="status status-warning">409</span></td>
                <td>Conflict</td>
                <td>Запрос с таким ID уже существует</td>
                <td>Feedback ID уже используется</td>
              </tr>
              </tbody>
            </table>
          </div>

          <h3>Ошибки сервера</h3>
          <div class="table-container">
            <table>
              <thead>
              <tr>
                <th>Код</th>
                <th>Статус</th>
                <th>Описание</th>
                <th>Причина</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td><span class="status status-error">500</span></td>
                <td>Internal Server Error</td>
                <td>Внутренняя ошибка сервиса</td>
                <td>Проблемы на стороне сервера, временная недоступность</td>
              </tr>
              <tr>
                <td><span class="status status-error">502</span></td>
                <td>Bad Gateway</td>
                <td>Ошибка при отправке callback</td>
                <td>Не удалось отправить PDF на ваш сервер</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="card">
          <div class="card-header">
            <div class="card-icon">
              <i class="fas fa-redo"></i>
            </div>
            <div>
              <h2 class="card-title">Повторные попытки отправки</h2>
              <p class="card-subtitle">Автоматический retry механизм</p>
            </div>
          </div>

          <p>Сервис автоматически повторяет отправку callback при ошибках:</p>

          <div class="table-container">
            <table>
              <thead>
              <tr>
                <th>Попытка</th>
                <th>Задержка</th>
                <th>Общее время</th>
                <th>Условия</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>1</td>
                <td>Немедленно</td>
                <td>0 минут</td>
                <td>Первая попытка отправки</td>
              </tr>
              <tr>
                <td>2</td>
                <td>2 минуты</td>
                <td>2 минуты</td>
                <td>После первой неудачи</td>
              </tr>
              <tr>
                <td>3</td>
                <td>10 минут</td>
                <td>12 минут</td>
                <td>После второй неудачи</td>
              </tr>
              <tr>
                <td>4</td>
                <td>50 минут</td>
                <td>1 час 2 минуты</td>
                <td>После третьей неудачи</td>
              </tr>
              <tr>
                <td>5</td>
                <td>2 часа 5 минут</td>
                <td>3 часа 7 минут</td>
                <td>После четвертой неудачи</td>
              </tr>
              <tr>
                <td>6</td>
                <td>5 часов</td>
                <td>8 часов 7 минут</td>
                <td>После пятой неудачи</td>
              </tr>
              </tbody>
            </table>
          </div>

          <div class="alert alert-warning">
            <div class="alert-icon">
              <i class="fas fa-exclamation-circle"></i>
            </div>
            <div>
              <strong>Важно:</strong> После 6 неудачных попыток запрос помечается как неудавшийся и повторные отправки
              прекращаются. Убедитесь, что ваш сервер доступен и правильно обрабатывает входящие запросы.
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-header">
            <div class="card-icon">
              <i class="fas fa-tasks"></i>
            </div>
            <div>
              <h2 class="card-title">Чек-лист интеграции</h2>
              <p class="card-subtitle">Пошаговая проверка готовности</p>
            </div>
          </div>

          <ul class="feature-list">
            <li><strong>Получены учетные данные:</strong> API ключ, client_id, secret_key, ключ шифрования</li>
            <li><strong>Настроен callback-endpoint:</strong> HTTPS, доступен извне, правильный домен</li>
            <li><strong>Реализована отправка запросов:</strong> Шифрование, подпись, правильные заголовки</li>
            <li><strong>Реализована обработка callback:</strong> Проверка подписи, расшифровка, сохранение файла</li>
            <li><strong>Настроено логирование:</strong> Запись всех операций и ошибок</li>
            <li><strong>Протестирован полный цикл:</strong> Отправка → Обработка → Получение PDF</li>
            <li><strong>Настроены уведомления:</strong> Ошибки, успешные доставки, проблемы с доступностью</li>
            <li><strong>Документировано:</strong> Процессы интеграции для команды поддержки</li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <footer>
      <div class="container">

        <div class="copyright">
          <p>© 2026 ООО «Орион Солюшенс». Все права защищены.</p>
          <p>Версия API: 2.0 </p>
        </div>
      </div>
    </footer>

  </main>
</template>

<script>

export default {
  name: "ExternalDoc",
  mounted() {
    // Табы для языков программирования
document.querySelectorAll('.lang-tab').forEach(tab => {
    tab.addEventListener('click', () => {
        // Убираем активный класс у всех табов
        document.querySelectorAll('.lang-tab').forEach(t => t.classList.remove('active'));
        document.querySelectorAll('.tab-content2').forEach(c => c.classList.remove('active'));

        // Добавляем активный класс к выбранному табу
        tab.classList.add('active');

        // Показываем соответствующий контент
        const lang = tab.getAttribute('data-lang');
        document.getElementById(`${lang}-tab`).classList.add('active');
    });
});
    document.querySelectorAll('.nav-tab').forEach(tab => {
      tab.addEventListener('click', () => {
        // Remove active class from all tabs and contents
        document.querySelectorAll('.nav-tab').forEach(t => t.classList.remove('active'));
        document.querySelectorAll('.tab-content').forEach(c => c.classList.remove('active'));

        // Add active class to clicked tab
        tab.classList.add('active');

        // Show corresponding content
        const tabId = tab.getAttribute('data-tab');
        document.getElementById(tabId).classList.add('active');
      });
    });

    // Copy code functionality
    function copyCode(elementId) {
      const codeElement = document.getElementById(elementId);
      const textArea = document.createElement('textarea');
      textArea.value = codeElement.textContent;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);

      // Show feedback
      const copyBtn = event.target.closest('.copy-btn');
      const originalText = copyBtn.innerHTML;
      copyBtn.innerHTML = '<i class="fas fa-check"></i> Скопировано!';
      copyBtn.style.backgroundColor = '#28a745';

      setTimeout(() => {
        copyBtn.innerHTML = originalText;
        copyBtn.style.backgroundColor = '';
      }, 2000);
    }

    // Smooth scroll for anchor links
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function (e) {
        e.preventDefault();

        const targetId = this.getAttribute('href');
        if (targetId === '#') return;

        const targetElement = document.querySelector(targetId);
        if (targetElement) {
          window.scrollTo({
            top: targetElement.offsetTop - 20,
            behavior: 'smooth'
          });
        }
      });
    });

    // Highlight current section based on scroll
    window.addEventListener('scroll', () => {
      const sections = document.querySelectorAll('.tab-content');
      const navTabs = document.querySelectorAll('.nav-tab');
      const scrollPosition = window.scrollY + 100;

      sections.forEach((section, index) => {
        const sectionTop = section.offsetTop;
        const sectionHeight = section.clientHeight;

        if (scrollPosition >= sectionTop && scrollPosition < sectionTop + sectionHeight) {
          navTabs.forEach(tab => tab.classList.remove('active'));
          navTabs[index].classList.add('active');

          document.querySelectorAll('.tab-content').forEach(c => c.classList.remove('active'));
          section.classList.add('active');
        }
      });
    });
  },

  methods: {},
}
</script>
<style scoped lang="scss">
.dashboard {
  --primary: #4361ee;
  --primary-dark: #3a56d4;
  --secondary: #7209b7;
  --success: #4cc9f0;
  --warning: #f72585;
  --light: #f8f9fa;
  --dark: #212529;
  --gray: #6c757d;
  --light-gray: #e9ecef;
  --border-radius: 8px;
  --box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  --transition: all 0.3s ease;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  line-height: 1.6;
  color: var(--dark);
  background-color: #f5f7ff;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* Header */
header {
  background: linear-gradient(135deg, var(--primary) 0%, var(--secondary) 100%);
  color: white;
  padding: 2rem 0;
  margin-bottom: 2rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo {
  display: flex;
  align-items: center;
  gap: 15px;
}

.logo-icon {
  font-size: 2.5rem;
  color: var(--success);
}

.logo-text h1 {
  font-size: 2.2rem;
  margin-bottom: 5px;
}

.logo-text p {
  opacity: 0.9;
  font-size: 1rem;
}

.version {
  background-color: rgba(255, 255, 255, 0.2);
  padding: 8px 15px;
  border-radius: 20px;
  font-weight: 600;
}

/* Navigation */
.nav-tabs {
  display: flex;
  background-color: white;
  border-radius: var(--border-radius);
  box-shadow: var(--box-shadow);
  margin-bottom: 2rem;
  overflow: hidden;
}

.nav-tab {
  flex: 1;
  text-align: center;
  padding: 1.2rem;
  cursor: pointer;
  font-weight: 600;
  transition: var(--transition);
  border-bottom: 3px solid transparent;
  color: var(--gray);
}

.nav-tab:hover {
  background-color: var(--light-gray);
  color: var(--primary);
}

.nav-tab.active {
  color: var(--primary);
  border-bottom: 3px solid var(--primary);
  background-color: rgba(67, 97, 238, 0.05);
}

.tab-content {
  display: none;
}

.tab-content.active {
  display: block;
  animation: fadeIn 0.5s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Cards */
.card {
  background-color: white;
  border-radius: var(--border-radius);
  box-shadow: var(--box-shadow);
  padding: 2rem;
  margin-bottom: 2rem;
  transition: var(--transition);
}

.card:hover {
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
}

.card-header {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid var(--light-gray);
}

.card-icon {
  font-size: 1.8rem;
  color: var(--primary);
  background-color: rgba(67, 97, 238, 0.1);
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.card-title {
  font-size: 1.5rem;
  color: var(--dark);
}

.card-subtitle {
  color: var(--gray);
  font-size: 0.95rem;
}

/* Code blocks */
.code-block {
  background-color: #1e1e1e;
  color: #d4d4d4;
  border-radius: var(--border-radius);
  padding: 1.5rem;
  margin: 1.5rem 0;
  overflow-x: auto;
  font-family: 'Courier New', monospace;
  font-size: 0.9rem;
  line-height: 1.5;
}

.code-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  padding-bottom: 0.8rem;
  border-bottom: 1px solid #333;
}

.code-title {
  color: #ccc;
  font-weight: 600;
}

.copy-btn {
  background-color: #333;
  color: #ccc;
  border: none;
  padding: 5px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.8rem;
  transition: var(--transition);
}

.copy-btn:hover {
  background-color: #444;
  color: white;
}

.keyword {
  color: #569cd6;
}

.string {
  color: #ce9178;
}

.function {
  color: #dcdcaa;
}

.comment {
  color: #6a9955;
}

.number {
  color: #b5cea8;
}

/* Tables */
.table-container {
  overflow-x: auto;
  margin: 1.5rem 0;
}

table {
  width: 100%;
  border-collapse: collapse;
  margin: 1.5rem 0;
}

th {
  background-color: var(--primary);
  color: white;
  text-align: left;
  padding: 1rem;
  font-weight: 600;
}

td {
  padding: 1rem;
  border-bottom: 1px solid var(--light-gray);
}

tr:nth-child(even) {
  background-color: rgba(0, 0, 0, 0.02);
}

tr:hover {
  background-color: rgba(67, 97, 238, 0.05);
}

.required {
  color: var(--warning);
  font-weight: 600;
}

/* Status indicators */
.status {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 600;
}

.status-success {
  background-color: rgba(76, 201, 240, 0.2);
  color: #4cc9f0;
}

.status-warning {
  background-color: rgba(247, 37, 133, 0.2);
  color: #f72585;
}

.status-error {
  background-color: rgba(220, 53, 69, 0.2);
  color: #dc3545;
}

/* Lists */
.feature-list {
  list-style-type: none;
  margin: 1.5rem 0;
}

.feature-list li {
  padding: 10px 0;
  border-bottom: 1px solid var(--light-gray);
  display: flex;
  align-items: center;
  gap: 10px;
}

.feature-list li:before {
  content: "✓";
  color: var(--success);
  font-weight: bold;
  font-size: 1.2rem;
}

/* Alerts */
.alert {
  padding: 1.2rem;
  border-radius: var(--border-radius);
  margin: 1.5rem 0;
  display: flex;
  align-items: flex-start;
  gap: 15px;
}

.alert-icon {
  font-size: 1.5rem;
  margin-top: 2px;
}

.alert-info {
  background-color: rgba(76, 201, 240, 0.1);
  border-left: 4px solid var(--success);
}

.alert-warning {
  background-color: rgba(247, 37, 133, 0.1);
  border-left: 4px solid var(--warning);
}

.alert-success {
  background-color: rgba(40, 167, 69, 0.1);
  border-left: 4px solid #28a745;
}

/* Two-column layout */
.two-column {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  margin: 2rem 0;
}

@media (max-width: 992px) {
  .two-column {
    grid-template-columns: 1fr;
  }
}

/* Footer */
footer {
  background-color: var(--dark);
  color: white;
  padding: 3rem 0;
  margin-top: 3rem;
}

.footer-content {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 2rem;
}

.footer-section h3 {
  margin-bottom: 1.5rem;
  color: var(--success);
}

.footer-section ul {
  list-style-type: none;
}

.footer-section li {
  margin-bottom: 10px;
}

.footer-section a {
  color: #ccc;
  text-decoration: none;
  transition: var(--transition);
}

.footer-section a:hover {
  color: var(--success);
}

.copyright {
  text-align: center;
  margin-top: 3rem;
  padding-top: 1.5rem;
  border-top: 1px solid #444;
  color: #aaa;
  font-size: 0.9rem;
}

/* Mobile responsiveness */
@media (max-width: 768px) {
  .header-content {
    flex-direction: column;
    text-align: center;
    gap: 20px;
  }

  .nav-tabs {
    flex-direction: column;
  }

  .footer-content {
    flex-direction: column;
  }
}

/* Tabs content */
.endpoint {
  margin-bottom: 2rem;
  padding-bottom: 2rem;
  border-bottom: 1px solid var(--light-gray);
}

.endpoint:last-child {
  border-bottom: none;
}

.endpoint-method {
  display: inline-block;
  padding: 6px 15px;
  background-color: var(--primary);
  color: white;
  border-radius: 4px;
  font-weight: 600;
  margin-right: 10px;
}

.endpoint-path {
  font-family: 'Courier New', monospace;
  font-weight: 600;
  color: var(--dark);
}

.endpoint-description {
  margin: 15px 0;
  color: var(--gray);
}
.language-tabs {
    margin: 20px 0;
}

.tab-buttons {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    margin-bottom: 15px;
}

.lang-tab {
    padding: 10px 20px;
    background: #f8f9fa;
    border: 1px solid #dee2e6;
    border-radius: 5px 5px 0 0;
    cursor: pointer;
    font-weight: 600;
    color: #6c757d;
    transition: all 0.3s ease;
}

.lang-tab:hover {
    background: #e9ecef;
    color: #495057;
}

.lang-tab.active {
    background: #4361ee;
    color: white;
    border-color: #4361ee;
}

.tab-content2 {
    display: none;
}

.tab-content2.active {
    display: block;
    animation: fadeIn 0.3s ease;
}

.process-flow {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 30px 0;
    position: relative;
}

.process-step {
    text-align: center;
    flex: 1;
    position: relative;
    z-index: 2;
}

.step-icon {
    width: 70px;
    height: 70px;
    background: white;
    border: 3px solid #4361ee;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 15px;
    font-size: 1.8rem;
    color: #4361ee;
    box-shadow: 0 5px 15px rgba(67, 97, 238, 0.2);
}

.step-arrow {
    position: absolute;
    top: 35px;
    left: 50%;
    width: 100px;
    height: 3px;
    background: #4361ee;
    transform: translateX(-50%);
    z-index: 1;
}

.step-arrow:after {
    content: "";
    position: absolute;
    right: -10px;
    top: -5px;
    border-left: 10px solid #4361ee;
    border-top: 8px solid transparent;
    border-bottom: 8px solid transparent;
}

@media (max-width: 768px) {
    .process-flow {
        flex-direction: column;
    }

    .step-arrow {
        display: none;
    }
}

</style>